import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * O `twMerge` precisa conhecer os tamanhos que o nosso tema acrescenta.
 *
 * Ele classifica `text-<algo>` como **cor** quando `<algo>` não é um tamanho
 * que ele reconheça. Então `cn("text-field", "text-foreground")` entendia as
 * duas como cor, tratava como conflito e **descartava a primeira em silêncio** —
 * o campo ficava sem tamanho declarado e ninguém via erro.
 *
 * Medido em 2026-09-08: o `className` que chegava ao `TextInput` vinha sem o
 * `text-field`. Por isso a lista abaixo não é enfeite; ela tem de acompanhar o
 * `fontSize` dos `tailwind.config` dos apps.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["2xs", "field"] }],
    },
  },
});

/**
 * Junta classes resolvendo conflito de Tailwind.
 *
 * Estava escrito duas vezes, com o mesmo corpo e as mesmas duas bibliotecas —
 * em `apps/web/src/lib/utils.ts` e em `apps/mobile/src/ui/cn.ts`, este último
 * com o comentário "mesma assinatura do `cn` do web". Não é caso de decidir
 * nada: é a mesma função.
 *
 * Os dois apps continuam exportando `cn` dos caminhos de sempre, agora
 * reexportando daqui. Nenhum dos 300 arquivos que importam precisou mudar.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export type { ClassValue };
